import React, {useContext} from "react";
import './ClientInvoice2.css'
import Invoice2Header from "./Invoice2Header";
import {RecordsManagementContext,ViewMangementContext} from "../StatesMangement/InitialiseContext";
import CompanyBranchAndEstimateInfo from "./CompanyBranchAndEstimateInfo";
import ClientInfo from "./ClientInfo";
import EstimateAddress from "./EstimateAddress";
import EstimateNotes from "./EstimateNotes";
import PackingAndMovingDates from "./PackingAndMovingDates";
import PackingServiceAndMaterials from "./PackingServiceAndMaterials";
import NotesAndComments from "./NotesAndComments";
import AdditionalTerms from "./AdditionalTerms";
import TimeRecords from "./TimeRecords";
import MoveDetails from "./MoveDetails";
import {JobCharge, JobChargeForEstimateAdditionalCharges, JobChargeWithExtraColumn} from "./JobCharge";
import JobSignaturesInfo from "./JobSignaturesInfo";
import DefaultModal from "../CommonComponents/DefaultModal";
import DefaultAlerts from "../CommonComponents/DefaultAlerts";

export default () => {
    let Record = useContext(RecordsManagementContext)
    let PageView = useContext(ViewMangementContext)
    let IV2_PageDetails = Record.IV2_PageDetails
    let backgroundColor1 = IV2_PageDetails.CompanyBranchAndEstimateInfo.BgColor1
    let backgroundColor2 = IV2_PageDetails.CompanyBranchAndEstimateInfo.BgColor2
    let checkExtraColumn = IV2_PageDetails.JobDetails.TruckAndEquipmentFee.ExtraValue === '' ? <JobCharge  Charge={IV2_PageDetails.JobDetails.TruckAndEquipmentFee}/> : <JobChargeWithExtraColumn  Charge={IV2_PageDetails.JobDetails.TruckAndEquipmentFee}/>
    return (
        <div style={{backgroundColor: "#172b4d", backgroundImage:  `linear-gradient(45deg, ${backgroundColor1} 15%, ${backgroundColor2} 85%)`}}>
            <div className='width-wrapper'>
                <DefaultAlerts/>
            </div>
            <div className='width-wrapper px-4'>
                <table className="table">
                    <thead className={"is-sticky"} style={{height: "50px", top: 0}}>
                    <tr>
                        <th className="td-main-bost wid-sticky" style={{paddingTop: "0px"}} colSpan="2">
                            <Invoice2Header/>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="td-main-bost" colSpan="2" style={{paddingTop: "50px"}}>
                            <CompanyBranchAndEstimateInfo/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost" colSpan="2">
                            <ClientInfo/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost" colSpan="2">
                            <EstimateAddress/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost" colSpan="2">
                            <EstimateNotes/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost" colSpan="2">
                            <PackingAndMovingDates/>
                        </td>
                    </tr>
                    <td className="td-main-bost" colSpan={2}>
                        <tr>
                            <td className="td-main-bost" colSpan={2} rowSpan="2">
                                <PackingServiceAndMaterials/>
                                <NotesAndComments/>
                                <AdditionalTerms/>
                            </td>
                            <td className="td-main-bost" colSpan={2} >
                                <TimeRecords/>
                                <MoveDetails/>
                                <div className='small mt-2 border border-dark py-3'>
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.MovingFee}/>
                                    <JobChargeWithExtraColumn Charge={IV2_PageDetails.JobDetails.OvertimeHours}/>
                                    {checkExtraColumn}
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.BaseFee}/>
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.FuelSurcharge}/>
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.PackingFee}/>
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.PackingMaterials}/>
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.StorageFee}/>
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.WarehouseHandling}/>
                                    {IV2_PageDetails.JobDetails && IV2_PageDetails.JobDetails.Discount.ExtraValue == ''
                                        && (
                                            <JobCharge Charge={IV2_PageDetails.JobDetails.Discount}/>
                                        )}
                                    <JobChargeForEstimateAdditionalCharges
                                        Charge={IV2_PageDetails.JobDetails.EstimateAdditionalChargeSubTotals}/>
                                    {IV2_PageDetails.JobDetails && IV2_PageDetails.JobDetails.Discount.ExtraValue != '' && IV2_PageDetails.JobDetails.Discount.ExtraValue
                                    && (
                                        <JobCharge Charge={IV2_PageDetails.JobDetails.Discount}/>
                                    )}
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.SubTotal}/>
                                    <JobChargeForEstimateAdditionalCharges
                                        Charge={IV2_PageDetails.JobDetails.EstimateAdditionalCharges}/>
                                    {IV2_PageDetails.JobDetails && IV2_PageDetails.JobDetails.Discount.ExtraValue != '' && !IV2_PageDetails.JobDetails.Discount.ExtraValue
                                    && (
                                        <JobCharge Charge={IV2_PageDetails.JobDetails.Discount}/>
                                    )}
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.Tip}/>
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.CCProcessingFee}/>
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.SurCharge}/>
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.Automation}/>
                                    {Record.NewTotalCost.toString() != '' ? <JobCharge Charge={{Name: IV2_PageDetails.JobDetails.GrandTotal.Name, Value: Record.NewTotalCost.toString(), ExtraValue: IV2_PageDetails.JobDetails.GrandTotal.ExtraValue, Currency: IV2_PageDetails.JobDetails.GrandTotal.Currency, Show: false}}/> :
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.GrandTotal}/> }
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.NotToExceedTotal}/>
                                    <JobCharge Charge={IV2_PageDetails.JobDetails.Payments}/>
                                    {Record.NewBalanceDue.toString() != '' ? <JobCharge Charge={{Name: IV2_PageDetails.JobDetails.BalanceDue.Name, Value: Record.NewBalanceDue.toString(), ExtraValue: IV2_PageDetails.JobDetails.BalanceDue.ExtraValue, Currency: IV2_PageDetails.JobDetails.BalanceDue.Currency, Show: false}}/> :
                                        <JobCharge Charge={IV2_PageDetails.JobDetails.BalanceDue}/>}
                                </div>
                            </td>
                        </tr>
                    </td>
                    <tr>
                        <td className="td-sign"  colSpan={2}>
                            <JobSignaturesInfo Signature={IV2_PageDetails.Signatures.shipper_sign_3}/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-sign" ><JobSignaturesInfo Signature={IV2_PageDetails.Signatures.shipper_sign_4}/></td>
                        <td className="td-sign"><JobSignaturesInfo Signature={IV2_PageDetails.Signatures.carrier_sign_1}/></td>
                    </tr>
                    <tr>
                        <td className="td-sign"><JobSignaturesInfo Signature={IV2_PageDetails.Signatures.shipper_sign_5}/></td>
                        <td className="td-sign"><JobSignaturesInfo Signature={IV2_PageDetails.Signatures.carrier_sign_2}/></td>
                    </tr>
                    <tr>
                        <td className="td-sign"><JobSignaturesInfo Signature={IV2_PageDetails.Signatures.shipper_sign_6}/></td>
                        <td className="td-sign"><JobSignaturesInfo Signature={IV2_PageDetails.Signatures.carrier_sign_3}/></td>
                    </tr>
                    </tbody>
                </table>
                <DefaultModal/>
            </div>
        </div>
    )
}